import React, { FC, ReactElement } from 'react';

import ActivityFeedJoyride from '@buyside/components/presentation/Joyride/ActivityFeedJoyride/activityFeedJoyride';
import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import HomePageComments from '@buyside/components/presentation/HomePage/homePageComments';
import HomePageIdeaUpdates from '@buyside/components/presentation/HomePage/homePageIdeaUpdates';
import HomePageTrendingIdeas from '@buyside/components/presentation/HomePage/HomePageTrendingIdeas/homePageTrendingIdeas';
import Icon from '@buyside/components/presentation/Icon/icon';
import IdeaIndexPage from '@buyside/components/presentation/IdeaIndexPage/ideaIndexPage';
import Tabs, { TabContent, TabNav } from '@buyside/components/presentation/Tabs/tabsComponents';

import LightBulbIcon from '@buyside/svgs/lightbulb.svg';
import LightBulbPlusIcon from '@buyside/svgs/lightbulb_plus.svg';
import MessageBubbleIcon from '@buyside/svgs/message_bubble.svg';

import styles from '@buyside/components/presentation/HomePage/homePageStyles.scss';

export const MobileHome: FC<{
  children: ReactElement;
  renderFilters: () => ReactElement;
}> = ({ children, renderFilters }) => (
  <>
    {renderFilters()}
    <Tabs>
      <TabNav className={styles.mobileTabNav}>
        <div>
          <Icon className={styles.tabIcon} type={LightBulbIcon} />
          Ideas
        </div>
        <div>
          <Icon className={styles.tabIcon} type={LightBulbPlusIcon} /> Idea Updates
        </div>
        <div>
          <Icon className={styles.tabIcon} type={MessageBubbleIcon} /> Comments
        </div>
      </TabNav>
      <TabContent>
        {children}
        <HomePageIdeaUpdates />
        <HomePageComments />
      </TabContent>
    </Tabs>
  </>
);

export const HomeAside = (): ReactElement => (
  <div className={styles.homeAside}>
    <Tabs defaultId={1}>
      <TabNav>
        <div>
          <Icon className={styles.tabIcon} type={LightBulbPlusIcon} /> Idea Updates
        </div>
        <div>
          <Icon className={styles.tabIcon} type={MessageBubbleIcon} /> Comments
        </div>
      </TabNav>
      <TabContent>
        <HomePageIdeaUpdates />
        <HomePageComments />
      </TabContent>
    </Tabs>
  </div>
);

const HomePage = (): ReactElement => {
  return (
    <>
      <ActivityFeedJoyride />
      <HomePageTrendingIdeas />
      <ErrorBoundary pageName="home">
        <IdeaIndexPage isHome isPublic={false} />
      </ErrorBoundary>
    </>
  );
};

export default HomePage;
